import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment as ENV } from 'src/environments/environment';
import { StorageService } from '../../services/storage.service';
import SnackBar from '../components/snackbar/snackbar';
import { FORM_CAPTURE_IGNORE_KEYWORD, PRODUCT_ID, SC_AUTH_KEY } from '../../util/constant';

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    private storageService: StorageService,
    private _router: Router
  ) { }

  snackBar = new SnackBar();
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const apiKey = ENV.api.KEY;
    const userToken = this.storageService.getAuthUserToken();
    let language = this.storageService.getTranslationLang();
    let orgId = this.storageService.getUserOrg();
    let branchId = this.storageService.getUserBranch();
    let productUserUserCategoryId =
      this.storageService.getProductUserUserCategoryId();
    let productUserUserCategoryCode =
      this.storageService.getProductUserCategoryCode();
    let productUserUserCategoryName =
      this.storageService.getProductUserCategoryName();
    let userType = this.storageService.getUserType();

    if (language === 'French') {
      language = 'fr-FR';
    } else {
      language = 'en-US';
    }
    let updatedRequest = null;

    if (req.url.includes('p/users/')) {
      updatedRequest = req.clone(
        {
          headers: req.headers.set('sc-auth-key', SC_AUTH_KEY)
        }
      )
    }
    else if (
      !req.url.includes('unique-field-check') &&
      !req.url.includes('organization/create-updated') &&
      !req.url.includes('sign-up') &&
      !req.url.includes('verify-rc') &&
      !req.url.includes('verify-tin') &&
      !req.url.includes('brmetadata') &&
      !req.url.includes(`${FORM_CAPTURE_IGNORE_KEYWORD}`) &&
      !req.url.includes('templates')
    ) {
      updatedRequest = req.clone({
        headers: req.headers
          .set('Accept-Language', `${language || ''}`)
          .set('Authorization', `Bearer ${userToken}`)
          .set('Base-Product', PRODUCT_ID || '')
          .set('Base-Org', orgId || '')
          .set('Base-Branch', branchId || '')
          .set('api_key', `${apiKey || ''}`)
          .set('Base-Product-user-category-id', productUserUserCategoryId || '')
          .set(
            'Base-Product-user-category-code',
            productUserUserCategoryCode || ''
          )
          .set(
            'Base-Product-user-category-name',
            productUserUserCategoryName || ''
          )
          .set('Base-User-type', userType || ''),
      });
    } else {
      if (
        req.url.includes('sign-up') ||
        req.url.includes('organization/create-updated')
      ) {
        updatedRequest = req.clone({
          headers: req.headers
            .set('Accept-Language', `${language || ''}`)
            .set('Base-Product', PRODUCT_ID || '')
            .set('Base-Org', orgId || '')
            .set('Base-Branch', branchId || '')
            .set('api_key', `${apiKey || ''}`),
        });
      } else if (req.url.includes('templates')) {
        updatedRequest = req.clone({
          headers: req.headers.set('Access-Control-Allow-Origin', `*`),
        });
      }
      else {
        updatedRequest = req.clone({
          headers: req.headers
            .set('Accept-Language', `${language || ''}`)
            .set('api_key', `${apiKey || ''}`),
        });
      }
    }

    return next.handle(updatedRequest || req).pipe(
      tap(
        (res) => {
     
        },
        (err) => {
          if (err instanceof HttpErrorResponse) {
            if (err.error && err.error.description === 'Unauthorise') {
              // fire login
              // this.storageService.logoutToken();
              // what im doing here is that after 2 milli-secs i wanna store the return url on LS so the user can go back to where the
              // session caught them from.. in other to make it easy to navigate
              setTimeout(() => {
                localStorage.setItem('RETURN_URL', this._router.url);
                this._router.navigate(['login']);
              }, 2);
            } else if (err.status === 403) {
              // let make the title page empty cos we going back to the home page
              this._router.navigate(['/not-found']);
            } else if (err.status === 401) {
              this.storageService.logOut();
              this._router.navigate(['login']);
            }
          }
        }
      )
    );
  }
}
